import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles<string, { size: 'large' | 'small' }>(
  ({ colors }: ITheme) => ({
    input: {
      outline: 'none',
      background: 'transparent',
      boxSizing: 'border-box',
      color: colors.textField,
      display: 'block',
      lineHeight: '28px',
      width: '100%',

      border: `2px solid ${colors.borderColor}`,

      borderRadius: ({ size }) => (size === 'large' ? '16px' : '8px'),
      padding: ({ size }) => (size === 'large' ? '20px 24px' : '12px 16px'),
      fontSize: ({ size }) => (size === 'large' ? '20px' : '14px'),

      '& ::placeholder': {
        color: '#949494',
      },
      '&:focus, &:active': {
        color: colors.textField,
        background: 'transparent',
        borderColor: colors.secondary,
        outline: 'none',
      },

      '&.disabled': {
        background: '#F8F8F8',
        borderColor: '#F8F8F8',
        color: '#C9C9C9',
      },

      '&.error': {
        borderColor: '#E7000A',

        '&:focus, &:active': {
          borderColor: '#E7000A',
        },
      },
    },
    label: {
      display: 'block',
      fontWeight: FontWeight.SemiBold,
      color: 'var(--x-black-1)',
      margin: '0 0 8px 0',
      fontSize: ({ size }) => (size === 'large' ? '16px' : '12px'),
      lineHeight: '16px',
    },
    errorMsg: {
      color: '#E7000A',
      fontSize: '12px',
      lineHeight: '16px',
      marginTop: '4px',
      fontWeight: FontWeight.Medium,
    },
  }),
  {
    name: 'input',
  },
);

export default useStyles;
